"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.BcMenuV2Logout = void 0;
var common_constants_1 = require("../../../common/constants/common-constants");
var index_1 = require("../../../common/helpers/index");
var bc_menu_v2_constants_1 = require("./bc-menu-v2-constants");
var BcMenuV2Logout = (function () {
    function BcMenuV2Logout(mySelf, configLogout) {
        this.mySelf = mySelf;
        this.render(configLogout);
    }
    BcMenuV2Logout.prototype.render = function (configLogout) {
        this.createLogout(configLogout);
    };
    BcMenuV2Logout.prototype.createLogout = function (configLogout) {
        var emElementQuit = (0, index_1.createElement)({
            element: common_constants_1.BcCommonConstants.EM_TAG,
            classList: [common_constants_1.BcCommonConstants.ICONS_CLASS],
            innerText: bc_menu_v2_constants_1.BcMenuV2Constansts.BC_MENU_V2_ICON_QUIT,
        });
        var iElementLogin = (0, index_1.createElement)({
            element: common_constants_1.BcCommonConstants.I_TAG,
            classList: [common_constants_1.BcCommonConstants.ICONS_CLASS],
            innerText: bc_menu_v2_constants_1.BcMenuV2Constansts.BC_MENU_V2_ICON_LOGIN,
        });
        var iconButtonElementLogin = (0, index_1.createElement)({
            element: common_constants_1.BcCommonConstants.BUTTON_TAG,
            classList: [
                common_constants_1.BcCommonConstants.BC_ICON_BUTTON_TAG,
                common_constants_1.BcCommonConstants.BC_ICON_BUTTON_GHOST_CLASS,
                common_constants_1.BcCommonConstants.BC_ICON_BUTTON_MEDIUM_CLASS,
            ],
            children: [iElementLogin],
        });
        var divElement = (0, index_1.createElement)({
            element: common_constants_1.BcCommonConstants.DIV_TAG,
            props: { id: bc_menu_v2_constants_1.BcMenuV2Constansts.BC_MENU_V2_LOGOUT },
            children: [iconButtonElementLogin],
        });
        var buttonElement = (0, index_1.createElement)({
            element: common_constants_1.BcCommonConstants.BUTTON_TAG,
            classList: [common_constants_1.BcCommonConstants.BTN_SECONDARY_CLASS, common_constants_1.BcCommonConstants.BUTTON_SMALL_CLASS],
            innerText: !configLogout.text ? bc_menu_v2_constants_1.BcMenuV2Constansts.BC_MENU_V2_CLOSE_SESION : configLogout.text,
            children: [emElementQuit],
        });
        this.setLogoutConfig(emElementQuit, iElementLogin, iconButtonElementLogin, divElement, buttonElement);
    };
    BcMenuV2Logout.prototype.setLogoutConfig = function (emTag, iTag, iconButtonTag, divTag, buttonTag) {
        var _this = this;
        var menu = this.mySelf.querySelector(".".concat(bc_menu_v2_constants_1.BcMenuV2Constansts.BC_MENU_V2));
        emTag.setAttribute(common_constants_1.BcCommonConstants.ARIA_HIDDEN, bc_menu_v2_constants_1.BcMenuV2Constansts.BC_MENU_V2_TRUE);
        iTag.setAttribute(common_constants_1.BcCommonConstants.ARIA_HIDDEN, bc_menu_v2_constants_1.BcMenuV2Constansts.BC_MENU_V2_TRUE);
        iconButtonTag.setAttribute(common_constants_1.BcCommonConstants.ARIA_LABEL, bc_menu_v2_constants_1.BcMenuV2Constansts.BC_MENU_V2_CLOSE_SESION);
        divTag.append(buttonTag);
        menu.appendChild(divTag);
        buttonTag.addEventListener(common_constants_1.BcCommonConstants.EVENT_CLICK, function (event) {
            _this.onEventLogout(event);
        });
    };
    return BcMenuV2Logout;
}());
exports.BcMenuV2Logout = BcMenuV2Logout;
